const jobDetail = {
  Title: '#{neighborhood}, #{city} - #{clientName}',
  Loading: 'Loading job details...',
  DenyApplication: 'Deny',
  AcceptApplication: 'Accept',
  Accepted: 'Accepted',
  Pending: 'Pending',
  Denied: 'Denied',
  Rejected: 'Rejected',
  EmptyApplications: 'There are no applications here yet.',
  Tabs: {
    InternalApplications: 'Internal Applications (P:#{p} A:#{a} R:#{r})',
    ExternalApplications: 'External Applications (P:#{p} A:#{a} R:#{r})',
    Information: 'Information',
  },
  Day: {
    SU: 'Sunday',
    MO: 'Monday',
    TU: 'Tuesday',
    WE: 'Wednesday',
    TH: 'Thursday',
    FR: 'Friday',
    SA: 'Saturday',
  },
  Summary: {
    Languages: 'Languages: #{count}/#{total}',
    Certifications: 'Certifications: #{count}/#{total}',
    Considerations: 'Considerations: #{count}/#{total}',
    CanTravel: 'Can Travel: #{value}',
    Yes: 'Yes',
    No: 'No',
  },
  ConfirmAcceptTitle: 'Confirm Accept',
  ConfirmAcceptText: 'Are you sure you want to accept #{name} for this job?',
  Details: {
    Languages: 'Languages',
    Certifications: 'Certifications',
    Considerations: 'Considerations',
    AdditionalConsiderations: 'Additional Considerations',
    Travel: 'Travel',
    CanTravelToLocation: 'Can Travel To Location: #{value}',
    ScheduleAvailability: 'Schedule Availability',
  },
  Information: {
    AboutThisRole: 'About this role',
    ClientFor: 'Client for this position',
    Description: 'Description',
    Schedule: 'Schedule',
    StartDate: 'Expected start date',
    Compensation: 'Compensation',
    FlexibleStartTiming: 'Flexible start timing',
    CareNeeds: 'Care needs',
    SpecialConsiderations: 'Special considerations',
    AdditionalConsiderations: 'Additional considerations',
    NoSpecificRequirements: 'No specific requirements',
    NoSpecialConsiderations: 'No special considerations',
    WeeklyEarnings: '$#{amount}/week',
    BasedOnHours: 'Based on #{hours} hours/week',
    WeeklyHours: '#{hours} hours/week',
    HourlyRate: '$#{rate}/hr',
    Priorities: 'Priorities',
    Requirements: 'Requirements',
    LocationDisplay: '#{neighborhood}, #{city}',
    LiveIn: 'Live-in',
    JobURL: 'Job Application URL',
    CarePlan: {
      MOBILITY_SUPPORT: {
        Label: 'Mobility support',
        Description: 'Help with walking, transfers, or getting around',
      },
      MEDICATION_REMINDERS: {
        Label: 'Medication reminders',
        Description: 'Ensuring medications are taken on time',
      },
      MEAL_PREP: {
        Label: 'Meal prep',
        Description: 'Preparing nutritious meals and snacks',
      },
      LIGHT_HOUSEKEEPING: {
        Label: 'Light housekeeping',
        Description: 'Basic cleaning and tidying up',
      },
      TRANSPORTATION: {
        Label: 'Transportation',
        Description: 'Driving to appointments and errands',
      },
      COMPANIONSHIP: {
        Label: 'Companionship',
        Description: 'Social interaction and emotional support',
      },
      PERSONAL_CARE: {
        Label: 'Personal care',
        Description: 'Assistance with bathing, grooming, and dressing',
      },
      MEDICAL_APPOINTMENTS: {
        Label: 'Medical appointments',
        Description: 'Accompanying to and from medical visits',
      },
      SHOPPING_ASSISTANCE: {
        Label: 'Shopping assistance',
        Description: 'Help with grocery shopping and errands',
      },
      PET_CARE: {
        Label: 'Pet care',
        Description: 'Feeding, walking, and caring for pets',
      },
    },
    CertificationsOptions: {
      PSW: 'Personal Support Worker (PSW)',
      DSW: 'Developmental Service Worker (DSW)',
      PAB: 'Préposé aux bénéficiaires (PAB)',
      CNA: 'Certified Nursing Assistant (CNA)',
      HCA: 'Health Care Aide (HCA)',
      RNA: 'Registered Nursing Assistant (RNA)',
      RPN: 'Registered Practical Nurse (RPN)',
      RN: 'Registered Nurse (RN)',
      CPR: 'CPR Certification',
      FIRST_AID: 'First Aid Certification',
      PSW_STUDENT: 'PSW Student',
      NURSING_STUDENT: 'Nursing Student',
    },
    LanguageOptions: {
      ENGLISH: 'English',
      FRENCH: 'French',
      CHINESE: 'Chinese',
      HINDUSTANI: 'Hindustani',
      SPANISH: 'Spanish',
      PUNJABI: 'Punjabi',
      ARABIC: 'Arabic',
      TAGALOG: 'Tagalog',
      ITALIAN: 'Italian',
      GERMAN: 'German',
      PORTUGUESE: 'Portuguese',
      PERSIAN: 'Persian',
      RUSSIAN: 'Russian',
      TAMIL: 'Tamil',
      VIETNAMESE: 'Vietnamese',
      GUJARATI: 'Gujarati',
      POLISH: 'Polish',
      KOREAN: 'Korean',
      SERBO_CROATIAN: 'Serbo-Croatian',
      GREEK: 'Greek',
      HAITIAN_CREOLE: 'Haitian Creole',
      UKRAINIAN: 'Ukrainian',
      BENGALI: 'Bengali',
      ROMANIAN: 'Romanian',
      DUTCH: 'Dutch',
      CREE: 'Cree',
      JAPANESE: 'Japanese',
      HEBREW: 'Hebrew',
      TURKISH: 'Turkish',
      MALAYALAM: 'Malayalam',
      LITHUANIAN: 'Lithuanian',
      ILOCANO: 'Ilocano',
      SOMALI: 'Somali',
      SWAHILI: 'Swahili',
      TELUGU: 'Telugu',
      MANDARIN: 'Mandarin',
      CANTONESE: 'Cantonese',
      HINDI: 'Hindi',
    },
    ConsiderationsOptions: {
      COMFORTABLE_WITH_PETS: 'Comfortable working around pets',
      COMFORTABLE_WITH_STAIRS: 'Comfortable with stairs',
      NON_SMOKING_HOUSEHOLD: 'Non-smoking household preferred',
      PHYSICAL_LIFTING_REQUIRED: 'Physical lifting may be required',
      DEMENTIA_ALZHEIMER_EXPERIENCE: 'Experience with dementia/Alzheimer\'s',
      FLEXIBLE_SCHEDULE_CHANGES: 'Flexible with schedule changes',
    },
  },
  Settings: {
    SettingsDescription: 'Job settings',
    Contact: {
      Title: 'Contact information',
      Description: 'Manage who can see your contact details',
    },
  },
  ChangeStatusDialog: {
    Title: 'Change job status',
    Status: 'Status',
  },
  Status: {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
  },
  Evaluation: {
    Unknown: 'Unknown',
    Success: 'Success',
    Failure: 'Failure',
  },
  ExternalApplications: {
    Email: 'Email',
    Phone: 'Phone',
    Evaluation: 'Evaluation',
    Basic: 'Basic Qualification: #{label}',
    Communication: 'Communication: #{label}',
    Motivation: 'Motivation: #{label}',
    Biography: 'Biography',
    ShortBio: 'Short Bio',
    PersonalBio: 'Personal Bio',
    CaregiverMotivation: 'Caregiver Motivation',
    ContactInfo: 'Contact Information',
    FirstName: 'First Name',
    LastName: 'Last Name',
    Street: 'Street Address',
    City: 'City',
    Province: 'Province',
    PostalCode: 'Postal Code',
    DataCollection: 'Data Collection',
    Value: 'Value',
    Rationale: 'Rationale',
    EvaluationTitle: 'Evaluation',
    ScreeningStatus: 'Screening Status',
    ScreeningStatusLabel: 'Screening: #{label}',
    BasicEval: 'Basic Qualification',
    CommunicationEval: 'Communication Skills',
    MotivationEval: 'Motivation & Commitment',
    Status: 'Status',
    Description: 'Description',
    ConversationUrl: 'Conversation URL',
  },
};

export default jobDetail;
